import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { PhoneService } from 'src/app/shared/services/phone.service';
import { Phone } from 'src/app/shared/models/phone';
import { STATUS } from 'src/app/shared/phone-utils';

@Component({
  selector: 'app-order-tracking',
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate('300ms ease-in')),
      transition('true => false', animate('300ms ease-out'))
    ])
  ]
})
export class OrderTrackingComponent implements OnInit {

  readonly phone$: BehaviorSubject<Phone> = new BehaviorSubject<Phone>({} as Phone);
  collapsed = true;
  trackNumber = new FormControl('', [Validators.required]);

  constructor(
    public readonly translate: TranslateService,
    private readonly phoneService: PhoneService) { }

  ngOnInit(): void {

  }

  getPhoneByTrackNumber() {
    this.phoneService.findByTrackNumber(this.trackNumber.value).subscribe((phone: Phone) => {
      this.phone$.next(phone);
      this.collapsed = false;
    });
  }

  get status() {
    return STATUS;
  }
}